/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svtag_McpInputs */

const en_svtag_mcp = /** @type {(inputs: Svtag_McpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MCP`)
};

const ar_svtag_mcp = /** @type {(inputs: Svtag_McpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MCP`)
};

const bn_svtag_mcp = /** @type {(inputs: Svtag_McpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MCP`)
};

const de_svtag_mcp = /** @type {(inputs: Svtag_McpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MCP`)
};

const es_svtag_mcp = /** @type {(inputs: Svtag_McpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MCP`)
};

const fr_svtag_mcp = /** @type {(inputs: Svtag_McpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MCP`)
};

const pt_svtag_mcp = /** @type {(inputs: Svtag_McpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MCP`)
};

const zh_svtag_mcp = /** @type {(inputs: Svtag_McpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MCP`)
};

const tr_svtag_mcp = /** @type {(inputs: Svtag_McpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MCP`)
};

const ru_svtag_mcp = /** @type {(inputs: Svtag_McpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MCP`)
};

const pl_svtag_mcp = /** @type {(inputs: Svtag_McpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MCP`)
};

/**
* | output |
* | --- |
* | "#MCP" |
*
* @param {Svtag_McpInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svtag_mcp = /** @type {((inputs?: Svtag_McpInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svtag_McpInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svtag_mcp(inputs)
	if (locale === "bn") return bn_svtag_mcp(inputs)
	if (locale === "de") return de_svtag_mcp(inputs)
	if (locale === "es") return es_svtag_mcp(inputs)
	if (locale === "fr") return fr_svtag_mcp(inputs)
	if (locale === "pt") return pt_svtag_mcp(inputs)
	if (locale === "zh") return zh_svtag_mcp(inputs)
	if (locale === "tr") return tr_svtag_mcp(inputs)
	if (locale === "ru") return ru_svtag_mcp(inputs)
	if (locale === "pl") return pl_svtag_mcp(inputs)
	return en_svtag_mcp(inputs)
});